import axios from 'axios'
import jwt_decode from 'jwt-decode'

export class MyUploadAdapter {

    constructor(loader) {
      this.loader = loader;
  
      
      this.url = `${process.env.REACT_APP_BASE_URL_SERVER}/api/news/upload`;
  
      this.token = localStorage.getItem("accessToken");

      this.retry = 0
    }
  
    upload() {
      return new Promise(async (resolve, reject) => {
        this.loader.file.then(async (file) => {
          await this._refreshToken()  
          this._initRequest();
          this._initListeners(resolve, reject, file);
          this._sendRequest(file);
        });
      });
    }
  
    abort() {
      if (this.xhr) {
        this.xhr.abort();
      }
    }

    async _refreshToken() {
            
            let accessToken = localStorage.getItem('accessToken')
    
            let currentDate = new Date()
            const decodedToken = accessToken && jwt_decode(accessToken)

            if(decodedToken?.exp * 1000 < currentDate.getTime()) {
                try {
                    const response = await axios.get('http://localhost:5000/api/auth/refresh-token', { withCredentials: true })
                    if(response.data.success) {
                        localStorage.setItem('accessToken', response.data.accessToken)
                        this.token = response.data.accessToken
                    }
                } catch (error) {
                    console.log(error)
                }
            }
    }
  
    _initRequest() {

      const xhr = (this.xhr = new XMLHttpRequest());
      xhr.open("POST", this.url, true);
  
      // change "Authorization" header with your header
      xhr.setRequestHeader("Authorization", `Bearer ${this.token}`);
  
      xhr.responseType = "json";
    }
  
    _initListeners(resolve, reject, file) {
      const xhr = this.xhr;
      const loader = this.loader;
      const genericErrorText = "Couldn't upload file:" + file?.name;
  
      xhr.addEventListener("error", () => reject(genericErrorText));
      xhr.addEventListener("abort", () => reject());
  
      xhr.addEventListener("load", () => {
        const response = xhr.response;

        
        
        if (!response || response.error) {
            
          return reject(
            response && response.error ? response.error.message : genericErrorText
          );
        }
  
        
        resolve({
          default: response.url,
        });
      });
  
      if (xhr.upload) {
        xhr.upload.addEventListener("progress", (evt) => {
          if (evt.lengthComputable) {
            loader.uploadTotal = evt.total;
            loader.uploaded = evt.loaded;
          }
        });
      }
    }
  
    _sendRequest(file) {
      const data = new FormData();
  
      // change "attachments" key
      data.append("upload", file);
  
      this.xhr.send(data);
    }
  }